const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // matomoSiteId: 'xxxxxxxxx',
    // matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Comune di Toscolano Maderno',
      siteSubtitle: '',
      parentSiteTitle: 'Provincia di Brescia',
      parentSiteURL: 'https://www.provincia.brescia.it/',
      subsiteParentSiteTitle: 'Comune di Toscolano Maderno',
      arLoginUrl:
        'https://servizi.comune.toscolanomaderno.bs.it/rwe2/sso/generic/prelogin.jsp?ELANG=it&IATL=it',
      headerslimTertiaryMenu: {
        ...config.settings.siteProperties.headerslimTertiaryMenu,
        it: [
          {
            title: 'Versione precedente del sito',
            url: 'https://old.comune.toscolanomaderno.bs.it/',
          },
          {
            title: 'Amministrazione trasparente',
            url: 'https://toscolano.maggiolicloud.it/atti/menu.aspx',
          },
          {
            title: 'Albo pretorio',
            url:
              'https://albopretorio.sipalinformatica.it/sipal_ap/servlet/ListPubblicazione?codfisc=00581090982',
          },
        ],
      },
    },

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
        last_updated: '2023-12-11T12:43:00+00:00',
        technical: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
          choices: [
            {
              config_key: 'WAI',
              text: {
                it: {
                  title: 'Web Analytics Italia',
                  description:
                    "I cookie di Web Analytics Italia sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
                },
              },
            },
          ],
        },
      },
    },
  };

  config.settings.siteProperties.userLoggedMenu = [
    // overrides volto-io-prenoto
    // ...(config.settings.siteProperties.userLoggedMenu || []),
    {
      href: { it: 'https://servizi.comune.toscolanomaderno.bs.it/rwe2/user_console_mypage.jsp?ELANG=it' },
      // title: { it: 'Area personale' },
      title: { it: 'Le mie richieste' },
      roles: [],
      className: 'link-areaPersonale',
    },
  ];


  return config;
};

export default applyConfig;
